/* unplugin-vue-components disabled */import { render } from "./QuickScaleItem.vue?vue&type=template&id=06811008&scoped=true"
import script from "./QuickScaleItem.vue?vue&type=script&lang=js"
export * from "./QuickScaleItem.vue?vue&type=script&lang=js"

import "./QuickScaleItem.vue?vue&type=style&index=0&id=06811008&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06811008"]])

export default __exports__